
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line

/**
 * OffTimeType enum
 */
class OffTimeType {
  /**
   * Initialize enum with a given value
   * @param {OffTimeType|number|Int64|UInt64=} value Enum value, defaults is 0
   * @constructor
   */
  constructor (value = 0) {
    if (value instanceof OffTimeType) {
      this.value = value.value
    } else {
      this.value = value
    }
  }

  /**
   * Is this enum equal to other one?
   * @this {!OffTimeType}
   * @param {!OffTimeType} other Other enum
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof OffTimeType)) {
      throw new TypeError('Instance of OffTimeType is required!')
    }
    return this.value === other.value
  }

  /**
   * Get enum value
   * @this {!OffTimeType}
   * @returns {!number|!Int64|!UInt64} Enum value
   */
  valueOf () {
    return this.value
  }

  /**
   * Convert enum to string
   * @this {!OffTimeType}
   * @returns {!string} Enum value string
   */
  toString () {
    if (this.value === OffTimeType.ONCE.value) {
      return 'ONCE'
    }
    if (this.value === OffTimeType.WEEKLY.value) {
      return 'WEEKLY'
    }
    if (this.value === OffTimeType.MONTHLY.value) {
      return 'MONTHLY'
    }
    if (this.value === OffTimeType.YEARLY.value) {
      return 'YEARLY'
    }
    return '<unknown>'
  }

  /**
   * Inspect enum
   * @this {!OffTimeType}
   * @returns {!string} Enum value string
   */
  [util.inspect.custom] () {
    return this.toString()
  }

  /**
   * Convert enum to JSON
   * @this {!OffTimeType}
   * @returns {!number} Enum value for JSON
   */
  toJSON () {
    return this.value
  }

  /**
   * Create enum from object value
   * @param {!number} other Object value
   * @returns {!OffTimeType} Created enum
   */
  static fromObject (other) {
    return new OffTimeType(other)
  }
}

// noinspection PointlessArithmeticExpressionJS
OffTimeType.ONCE = new OffTimeType(0 + 0)
// noinspection PointlessArithmeticExpressionJS
OffTimeType.WEEKLY = new OffTimeType(0 + 1)
// noinspection PointlessArithmeticExpressionJS
OffTimeType.MONTHLY = new OffTimeType(0 + 2)
// noinspection PointlessArithmeticExpressionJS
OffTimeType.YEARLY = new OffTimeType(0 + 3)

export { OffTimeType };

/**
 * Fast Binary Encoding OffTimeType field model
 */
class FieldModelOffTimeType extends fbe.FieldModel {
  /**
   * Get the field size
   * @this {!FieldModelOffTimeType}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 1
  }

  /**
   * Get the value
   * @this {!FieldModelOffTimeType}
   * @param {OffTimeType=} defaults Default value, defaults is new OffTimeType()
   * @returns {!OffTimeType} Result value
   */
  get (defaults = new OffTimeType()) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return defaults
    }

    return new OffTimeType(this.readByte(this.fbeOffset))
  }

  /**
   * Set the value
   * @this {!FieldModelOffTimeType}
   * @param {!OffTimeType} value Value
   */
  set (value) {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return
    }

    this.writeByte(this.fbeOffset, value.value)
  }
}

export { FieldModelOffTimeType };
